<template>
  <div id="orderlist" style="width: 100%;height: 100%">
    <el-row>
      <el-form :inline="true" :model="searchForm" ref="searchForm" class="demo-form-inline"
        style="padding-top:0;margin-top:0">
        <el-col :xl="{ span: 5 }" :lg="{ span: 7 }" :md="{ span: 10 }" :sm="{ span: 10 }" :xs="{ span: 10 }">
          <el-form-item label="客户：">
            <el-select size="medium" filterable v-model="searchForm.customer" placeholder="请选择" clearable>
              <el-option v-for="item in customers" :key="item.ID" :label="item.AB_NAME" :value="item.ID">
              </el-option>
            </el-select>
          </el-form-item>
        </el-col>
        <el-col :xl="{ span: 5 }" :lg="{ span: 7 }" :md="{ span: 10 }" :sm="{ span: 10 }" :xs="{ span: 10 }">
          <el-form-item label="项目点：">
            <el-select size="medium" filterable v-model="searchForm.PROJECT" placeholder="请选择" clearable>
              <el-option v-for="item in points" :key="item.value" :label="item.PROJECT_NAME" :value="item.PROJECT_ID">
                <span style="float: left">{{ item.PROJECT_NAME }}</span>
              </el-option>
            </el-select>
          </el-form-item>
        </el-col>
        <el-col :xl="{ span: 5 }" :lg="{ span: 7 }" :md="{ span: 10 }" :sm="{ span: 10 }" :xs="{ span: 10 }">
          <el-form-item label="送货日期：">
            <el-date-picker size="medium" v-model="searchForm.SEND_DAY" type="date" value-format="yyyy-MM-dd" placeholder="选择日期">
            </el-date-picker>
          </el-form-item>
        </el-col>
        <el-col :xl="{ span: 5 }" :lg="{ span: 7 }" :md="{ span: 10 }" :sm="{ span: 10 }" :xs="{ span: 10 }">
          <el-form-item label="月份：">
            <el-date-picker size="medium" v-model="searchForm.MONTH" type="month" placeholder="选择月"></el-date-picker>
          </el-form-item>
        </el-col>
        <el-col :span="2">
          <el-form-item>
            <el-button size="medium" type="primary" id="search" @click="handleSearch()">筛选</el-button>
          </el-form-item>
        </el-col>
      </el-form>
    </el-row>
    <el-row>
      <el-col :span="4">
        <span>总收入：{{ totalFee }}元</span>
      </el-col>
      <el-col :span="4">
        <span>总成本：{{ totalCost }}元</span>
      </el-col>
      <el-col :span="4">
        <span>总利润：{{ realMoney }}元</span>
      </el-col>
    </el-row>
    <el-row v-loading="loading">
      <el-col :span="24">
        <el-table :data="newOrderListData" border stripe show-summary style="width: 100%;margin-top:10px">
          <el-table-column type="index" width="45" min-width="30" label="序号"></el-table-column>
          <!-- <el-table-column prop="ORDER_CODE" label="订单编号" min-width="270"></el-table-column> -->
          <el-table-column prop="SEND_DAY" label="送货日期" min-width="135"></el-table-column>
          <!-- <el-table-column prop="TC_NAME" label="公司" min-width="90"></el-table-column> -->
          <el-table-column prop="PROJECT_NAME" label="项目点" min-width="150"></el-table-column>
          <el-table-column prop="DK_NAME" label="档口" min-width="100"></el-table-column>
          <el-table-column prop="TOTAL_SUPPLIER_FEE" label="收入（元）" min-width="100"></el-table-column>
          <el-table-column prop="TOTAL_COST" label="成本（元）" min-width="100"></el-table-column>
          <el-table-column prop="PROFIT" label="利润（元）" min-width="100"></el-table-column>
          <el-table-column fixed="right" label="操作" width="200">
            <template slot-scope="scope">
              <el-button type="text" size="small" icon="el-icon-view" @click="detail(scope.row)">查看</el-button>
              <el-button type="text" size="small" icon="el-icon-view" @click="output(scope.row)">导出成本表</el-button>
            </template>
          </el-table-column>
        </el-table>
      </el-col>
    </el-row>
    <el-row>
      <el-col :span="24" style="text-align: right">
        <el-pagination @current-change="handleCurrentChange" :current-page.sync="currentPage" :page-size="pageSize"
          layout="total,prev, pager, next, jumper" :total="totalCount"></el-pagination>
      </el-col>
    </el-row>
  </div>
</template>
<script>
import http from '@/assets/common/http';
import date from '@/assets/common/date';

export default {
  data() {
    return {
      loading: true,
      loading1: '',
      shopName: '清美',
      managername: '老张',
      companys: [
        {
          TC_ID: '',
          AB_Name: '',
        },
      ],
      points: [
        {
          PROJECT_ID: '',
          PROJECT_NAME: '',
        },
      ],
      newOrderListData: [],
      currentPage: 1,
      totalCount: 0,
      pageSize: 10,
      searchForm: {
        COMPANY: '',
        PROJECT: '',
        STATUS: '',
        MONTH: date(new Date(), '%F').slice(0, 7),
      },
      index: 0,
      customers: [],
      totalCost: 0,
      totalFee: 0,
      realMoney: 0,
    };
  },
  created() {
    // 这里用来在设置中设置页面展示条目，文件在setting的generalSettings中，由前端控制条目，存储于localStorage中，key为SMP_PAGE_COUNT
    this.pageSize = Number(localStorage.getItem('SMP_PAGE_COUNT')) ? Number(localStorage.getItem('SMP_PAGE_COUNT')) : 10;
    if (this.SAVE_DSORDER_LIST) {
      this.searchForm = this.SAVE_DSORDER_LIST.CONDITION;
      this.currentPage = this.SAVE_DSORDER_LIST.CURRENT_PAGE;
    } else {
      this.currentPage = 1;
    }
    this.queryNewOrderListData();
    this.queryTitle();
  },
  computed: {
    // 上一次的搜索结果和条件
    SEARCH_DATA_CONDITION() {
      return this.$store.state.SEARCH_DATA_CONDITION;
    },
  },
  methods: {
    detail(row) {
      this.$router.push({ name: 'orderProfitDetail' });
      sessionStorage.setItem('orderId', row.ORDER_ID);
    },
    // 获取新订单列表
    queryNewOrderListData() {
      this.loading = true;
      const data = {
        PAGESIZE: this.pageSize,
        PAGEINDEX: this.currentPage - 1,
        SERVICE_ID: '10042',
        OTYPE: 6,
        SUPPLIER_ID: Number(sessionStorage.getItem('tcId')),
      };
      if (this.searchForm.customer) {
        data.TC_ID = this.searchForm.customer;
      }
      if (this.searchForm.PROJECT) {
        data.PROJECT_ID = this.searchForm.PROJECT;
      }
      if (this.searchForm.MONTH) {
        data.MONTH = date(this.searchForm.MONTH, '%F').slice(0, 7);
      }
      if (this.searchForm.SEND_DAY) {
        data.SEND_DAY = date(this.searchForm.SEND_DAY, '%F');
      }
      http.post(data).then((res) => {
        if (res.length != 0) {
          this.newOrderListData = res.length > 0 ? res[0].list : [];
          this.newOrderListData.forEach((item, index) => {
            item.PROFIT = Math.round((Number(item.TOTAL_SUPPLIER_FEE) - Number(item.TOTAL_COST)) * 100) / 100;
          });
          this.totalCount = res.length > 0 ? res[0].TOTAL_COUNT : [];
          this.loading = false;
          this.totalCost = res[0].TOTAL_COST;
          this.totalFee = res[0].TOTAL_FEE;
          this.realMoney = Math.round((Number(res[0].TOTAL_FEE) - Number(res[0].TOTAL_COST)) * 100) / 100;
        } else {
          this.newOrderListData = res;
          this.loading = false;
        }
      }).catch((error) => {
        this.$message.show({
          text: error,
          type: 'error',
        });
        this.loading = false;
      });
    },
    // 获取项目点信息列表
    queryTitle() {
      const params = {
        SERVICE_ID: '10042',
        OTYPE: 3,
        // OTYPE: 15,
        SUPPLIER_ID: Number(sessionStorage.getItem('tcId')),
      };
      http.post(params).then((res) => {
        this.customers = res.length > 0 ? res[0].company : [];
        this.points = res.length > 0 ? res[0].project : [];
      }).catch((error) => {
        this.$message.show({
          text: error,
          type: 'error',
        });
      });
    },
    output(row) {
      if (document.body.style.cursor === 'wait') {
      } else {
        document.body.style.cursor = 'wait';
        try {
          const params = {
            ORDER_ID: row.ORDER_ID,
            SERVICE_ID: '10042',
            OTYPE: 8,
            SUPPLIER_ID: Number(sessionStorage.getItem('tcId')),
          };
          http.post(params).then((result) => {
            window.location.href = this.$util.getURLLocalHost(result[0].FILE_PATH);
            document.body.style.cursor = 'default';
          }).catch((error) => {
            this.$message.show({
              text: error,
              type: 'error',
            });
            document.body.style.cursor = 'default';
          });
        } finally {}
      }
    },
    handleCurrentChange() {
      this.queryNewOrderListData();
    },
    // 点击筛选按钮触发
    handleSearch() {
      this.currentPage = 1;
      this.queryNewOrderListData();
    },
  },
};
</script>
<style scoped>
</style>



// WEBPACK FOOTER //
// src/components/costCenter/orderList.vue